
	import { defineComponent } from 'vue';

	import FiscalYearReportByParticipant from '@/ChildrenComponents/Reports/FiscalYearReportByParticipant.vue';

	import { IServiceUnitReport, IFiscalYearReportSearch } from '@/Models/Report/IPhaseReport';

    import { ReportService } from '@/Services/Report/report-service';

	export default defineComponent({
		name: 'service-unit-report',
		components: { FiscalYearReportByParticipant },
		data () {
			return {
				reportData: [] as IServiceUnitReport[],
				isSearching: false,
			}
		},
		methods: {
			getReportData(searchDto: IFiscalYearReportSearch) {
				this.isSearching = true;
				ReportService.getServiceUnitReportData(searchDto).then(response => this.reportData = response).finally(() => this.isSearching = false);
			}
		},
	});
